import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {AutomatService} from '../services/automat.service';
import {AddAutomat} from '../models/addAutomat';
import {Firms} from '../models/firms';
import {NgxSpinnerService} from 'ngx-spinner';
import {EditAutomat} from '../models/editAutomat';
import {StaffService} from '../services/staff.service';
import {AutomatBrandService} from '../services/automat-brand.service';
import {AutomatModelService} from '../services/automat-model.service';
import { GeocodingHelperService } from '../helpers/geocoding.helper';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FirmService } from '../services/firm.service';

declare var $: any;

@Component({
    selector: 'app-edit-automat',
    templateUrl: './edit-automat.component.html',
    styleUrls: ['./edit-automat.component.css']
})
export class EditAutomatComponent implements OnInit {

    @ViewChild('SuccessSwal') private SuccessSwal: SwalComponent;
    @ViewChild('ErrorSwal') private ErrorSwal: SwalComponent;

    // google maps zoom level
    zoom = 6;
    // initial center position for the map
    lat = 39.334943;
    lng = 35.177772;
    mapStyles: any;
    // END : Google maps variables

    mapAutomat: any = {};
    automat: EditAutomat;
    serviceAutomat: EditAutomat;
    cashlessConfig = {
        featureLevel: '', countryCode: '', scaleFactor: '', decimalPlaces: '', maxRespTime: '', miscOptions: '',
        automat: ''
    };

    // Service data variables
    public automatGroups: AddAutomat[] = [];
    public allFirms: Firms[] = [];
    public haveGroups: [any];
    public haveNotGroups: [any];
    public models = [];
    public devices = [];
    public vPoses = [];
    public beacons = [];
    public sims = [];
    public modems = [];
    public cities = [];
    public districts = [];
    public neighborhoods = [];
    public staffs = [];
    public brands = [];
    // END : Service data variables
    public firmId: string;
    public selectGroup;
    // Add image variables
    @ViewChild('cropInput') cropInput: ElementRef;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    cropperReady = false;
    selectedLocations = {city: '-1', district: '-1', neighborhood: '-1'};
    selectedBrand = '-1';
    // END : Add image variables
    public firm: any;
    public which: String;

    page = 1;
    pages = 1;
    loading = false;
    selector: string = '.edit-automat-list';

    constructor(private automatService: AutomatService,
                private automatBrandService: AutomatBrandService,
                private automatModelService: AutomatModelService,
                private firmService: FirmService,
                private staffService: StaffService,
                public activeModal: NgbActiveModal,
                private geocodingHelperService: GeocodingHelperService,
                private router: Router, private spinner: NgxSpinnerService) {

    }

    ngOnInit() {
        setTimeout(() => this.spinner.show());
        this.firm = localStorage.getItem('firm');
        this.firmId = localStorage.getItem('firmId');
        this.which = localStorage.getItem('which');
        this.getEditAutomat(localStorage.getItem('selectAutomat'));
        this.getCashlessConfig(localStorage.getItem('selectAutomat'));
        setTimeout(() => {
            /** spinner ends after 5 seconds */
            this.spinner.hide();
        }, 2000);
    }

    getEditAutomat(id) {
        this.clearAutomat();
        this.automatService.getAutomatInfo(id).subscribe(res => {
                console.log(res);
                Object.assign(this.automat, res);
                this.automat = res.automat;
                this.mapAutomat.lat = this.automat.location.coordinates[0];
                this.mapAutomat.lng = this.automat.location.coordinates[1];
                this.getSelectDatas(this.automat);
                this.getAutomatModels(this.automat.automatModel.automatBrand);
                Object.assign(this.serviceAutomat, this.automat);
                // this.serviceAutomat = this.automat;
            },
            error => {
                this.ErrorSwal.title = 'Hata';
                this.ErrorSwal.text = 'Düzenleme için gereken otomat bilgileri sunucudan getirilemedi!';
                this.ErrorSwal.show();
            });
    }

    getCashlessConfig(id) {
        this.automatService.getCashlessInfo(id).subscribe(res => {
                this.cashlessConfig.automat = res.automat;
                this.cashlessConfig.countryCode = res.countryCode;
                this.cashlessConfig.decimalPlaces = res.decimalPlaces;
                this.cashlessConfig.featureLevel = res.featureLevel;
                this.cashlessConfig.maxRespTime = res.maxRespTime;
                this.cashlessConfig.miscOptions = res.miscOptions;
                this.cashlessConfig.scaleFactor = res.scaleFactor;
                //  this.cashlessConfig._id = res._id;
            },
            error => {
                if (error.status === 404) {
                    return;
                }
                this.ErrorSwal.title = 'Hata';
                this.ErrorSwal.text = 'Düzenleme için cashless config bilgileri sunucudan getirilemedi!';
                this.ErrorSwal.show();
                this.spinner.hide();
            });
    }

    getSelectDatas(automat) {
        this.spinner.show();
        this.automatService.getAutomatGroupsByFirm(this.firmId).subscribe(response => {
            this.haveGroups = response.haveAutomats;
            this.haveNotGroups = response.haveNotAutomats;
            this.spinner.hide();

            for (const have of this.haveGroups) {
                this.automatGroups.push(have._id.group[0]);
            }
            for (const havent of this.haveNotGroups) {
                this.automatGroups.push(havent);
            }
        });
        this.automatService.getDevicesForAddAutomat(this.firmId).subscribe(Response => {
            this.spinner.hide();
            Response.dataDevices.forEach(data => {
                if (data.status === 0 || data._id === automat.device) {
                    this.devices.push(data);
                }
            });
        });
        this.automatService.getVPossesForAddAutomat(this.firmId).subscribe(Response => {
            this.spinner.hide();
            Response.dataVPos.forEach(data => {
                if (data.status === 0 || data._id === automat.vPos) {
                    this.vPoses.push(data);
                }
            });
        });
        this.automatService.getBeaconsForAddAutomat(this.firmId).subscribe(Response => {
            this.spinner.hide();
            Response.dataBeacons.forEach(data => {
                if (data.status === 0 || data._id === automat.beacon) {
                    this.beacons.push(data);
                }
            });
        });
        this.automatService.getSimsForAddAutomat(this.firmId).subscribe(Response => {
            this.spinner.hide();
            Response.dataSimCards.forEach(data => {
                if (data.status === 0 || data._id === automat.sim) {
                    this.sims.push(data);
                }
            });
        });
        this.automatService.getModemsForAddAutomat(this.firmId).subscribe(Response => {
            this.spinner.hide();
            Response.dataModems.forEach(data => {
                if (data.status === 0 || data._id === automat.modem) {
                    this.modems.push(data);
                }
            });
        });
        this.automatBrandService.getAllBrands(this.page).subscribe(res => {
            this.spinner.hide();
            this.brands = res.docs;
            this.pages = res.pages;
        });
        this.automatModelService.getAutomatModel(automat.automatModel).subscribe(res => {
            this.spinner.hide();
            if (res.success) {         
                this.selectedBrand = res.automatBrand;
                this.getAutomatModels(this.selectedBrand);
            } else {
                this.ErrorSwal.title = 'Hata';
                this.ErrorSwal.text = res.message;
                this.ErrorSwal.show();
            }
        }, error => {
            this.ErrorSwal.title = 'Hata';
            this.ErrorSwal.text = 'Otomatın bilgileri güncellenemedi!';
            this.ErrorSwal.show();
            this.spinner.hide();
        });
        console.log(this.automat.firm);
        this.staffService.getStaffByFirm(this.automat.firm).subscribe(Response => {
            this.spinner.hide();
            Response.result.forEach(data => {
                if (data.status === 0 || data._id === automat.operator) {
                    this.staffs.push(data);
                }
            });
        }, error => {
            console.log(error);
            if (error.status === 403) {
              localStorage.removeItem('token');
              localStorage.removeItem('user');
              this.router.navigate(['/login']);
            } else {
              this.ErrorSwal.title = error.status;
              this.ErrorSwal.text = error.error;
              this.ErrorSwal.show();
              console.log('Error:', error);
            }
          });
        this.automatService.getAllCities().subscribe(res => {
            this.spinner.hide();
            this.cities = res;
            for (const city of this.cities) {
                if (automat.province && city.cityTitle.toLowerCase() === automat.province.toLowerCase()) {
                    this.selectedLocations.city = city.cityKey;
                    break;
                }
            }
            this.automatService.getDistrictsByCity(this.selectedLocations.city).subscribe(res => {
                this.districts = res;
                for (const district of this.districts) {
                    if (district.districtTitle.toLowerCase() === automat.district.toLowerCase()) {
                        this.selectedLocations.district = district.districtKey;
                        break;
                    }
                }
                this.automatService.getNeighborhoodsByDistrict(this.selectedLocations.district).subscribe(res => {
                    this.neighborhoods = res;
                    for (const neighborhood of this.neighborhoods) {
                        if (neighborhood.neighborhoodTitle.toLowerCase() === automat.neighborhood.toLowerCase()) {
                            this.selectedLocations.neighborhood = neighborhood.neighborhoodKey;
                            break;
                        }
                    }
                });
            });
        });

        this.firmService.getAllFirms().subscribe(res => {
            this.spinner.hide();
            if (res.success) {
                this.allFirms = res.firms;
            }
        }, error => {
            this.spinner.hide();
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
            } else {
                this.ErrorSwal.title = error.status;
                this.ErrorSwal.text = error.error;
                this.ErrorSwal.show();
            }
        });
    }

    markerDragEnd($event: any) {
        this.mapAutomat.lat = $event.coords.lat;
        this.mapAutomat.lng = $event.coords.lng;
        this.automat.location.coordinates = [];
        this.automat.location.coordinates.push(this.mapAutomat.lat);
        this.automat.location.coordinates.push(this.mapAutomat.lng);
    }
    getAutomatModels(brand) {
        if (brand) {
            const automatBrandId = brand._id;
            this.spinner.show();
            this.automatModelService.getAutomatModelsByBrand(automatBrandId).subscribe(res => {
                this.models = res.data;
                this.spinner.hide();
            });
        }
    }
    onAutomatBrandChange(brand) {
        this.automat.automatModel._id = null;
        this.getAutomatModels(brand);
    }
    getDistricts(cityKey: string, name: string) {
        this.automat.province = name;
        console.log(cityKey, name);
        this.automatService.getDistrictsByCity(cityKey).subscribe(res => {
            this.districts = res;
            this.neighborhoods = [];
        });
    }

    getNeighborhoods(districtKey: string, name: string) {
        this.automat.district = name;
        this.automatService.getNeighborhoodsByDistrict(districtKey).subscribe(res => {
            this.neighborhoods = res;
        });
    }

    clearAutomat() {
        this.automat = new EditAutomat();
        this.serviceAutomat = new EditAutomat();

        // Reset image cropper
        this.cropInput.nativeElement.value = '';
        this.imageChangedEvent = '';
        this.croppedImage = '';
        this.cropperReady = false;
    }

    clickInputElement() {
        this.cropInput.nativeElement.click();
    }

    isCoinChange(e) {
        this.automat.isCoin = !!e;
    }

    isCardChange(e) {
        this.automat.isCard = !!e;
    }

    isPreSalesCardChange(e) {
        this.automat.isPreSalesCard = !!e;
    }

    isMobilChange(e) {
        this.automat.isMobil = !!e;
    }

    convertToFile(base64Str: string, fileName: string) {

        const binary = atob(base64Str.split(',')[1]);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new File([new Uint8Array(array)], this.automat._id + '.jpg',
            {type: 'image/jpeg', lastModified: Date.now()});
    }

    isFieldsOkay(): boolean {
        let isOkay = true;
        let which = '';
        if (this.automat.district === '' || this.automat.district === undefined) {
            isOkay = false;
            which = '1';
        }
        if (this.automat.group === '-1') {
            isOkay = false;
            which = '2';
        }
        if (this.automat.automatModel._id === '-1') {
            isOkay = false;
            which = '3';
        }
        if (this.automat.firm === '-1') {
            isOkay = false;
            which = '4';
        }
        if (this.automat.name === '' || this.automat.name === undefined) {
            isOkay = false;
            which = '5';
        }
        if (this.automat.neighborhood === '' || this.automat.neighborhood === undefined) {
            isOkay = false;
            which = '6';
        }
        if (this.automat.operator === '' || this.automat.operator === undefined) { isOkay = false; which = '7'; }
        if (this.automat.province === '' || this.automat.province === undefined) {
            isOkay = false;
            which = '8';
        }
        if (this.automat.serial === '' || this.automat.serial === undefined) {
            isOkay = false;
            which = '9';
        }
        if (this.automat.device === '-1') {
            isOkay = false;
            which = '10';
        }
        if (this.automat.vPos === '-1') {
            this.automat.vPos = null;
        }
        if (this.automat.beacon === '-1') {
            this.automat.beacon = null;
        }
        if (this.automat.sim === '-1') {
            this.automat.sim = null;
        }
        if (this.automat.modem === '-1') {
            this.automat.modem = null;
        }
        if (this.automat.location.coordinates.length === 0) {
            isOkay = false;
            which = '14';
        }
        if (this.cashlessConfig.countryCode === '' || this.cashlessConfig.countryCode === null) {
            isOkay = false;
            which = '15';
        }
        if (this.cashlessConfig.decimalPlaces === '' || this.cashlessConfig.decimalPlaces === null) {
            isOkay = false;
            which = '16';
        }
        if (this.cashlessConfig.featureLevel === '' || this.cashlessConfig.featureLevel === null) {
            isOkay = false;
            which = '17';
        }
        if (this.cashlessConfig.maxRespTime === '' || this.cashlessConfig.maxRespTime === null) {
            isOkay = false;
            which = '18';
        }
        if (this.cashlessConfig.miscOptions === '' || this.cashlessConfig.miscOptions === null) {
            isOkay = false;
            which = '19';
        }
        if (this.cashlessConfig.scaleFactor === '' || this.cashlessConfig.scaleFactor === null) {
            isOkay = false;
            which = '20';
        }
        if (isOkay) {
            return true;
        } else {
            this.ErrorSwal.title = 'Hata - ' + which;
            this.ErrorSwal.text = 'Lütfen açıklama alanı dışında boş alan bırakmayınız!\nOtomatın konumunu belirlemek için haritayı kullanınız!';
            this.ErrorSwal.show();
            return false;
        }
    }

    handleAutomat() {
        this.spinner.show();
        if (!this.isFieldsOkay()) {
            this.spinner.hide();
            return;
        }
        const data = this.getEditedDatas();
        this.automatService.updateAutomat(this.automat, this.cashlessConfig, this.serviceAutomat._id).subscribe(res => {
            this.automatService.updateCashlessConfig(this.cashlessConfig).subscribe(response => {
                if (this.croppedImage && this.croppedImage !== '') {
                    const formData = new FormData();
                    const ImageFile = this.convertToFile(this.croppedImage, this.cropInput.nativeElement.files[0].name);
                    formData.append('upfile', ImageFile);
                    this.automatService.addAutomatImage(formData, this.automat._id).subscribe(response => {
                        this.SuccessSwal.text = 'Otomat başarılı bir şekilde güncellendi!';
                        this.SuccessSwal.show();
                        this.spinner.hide();
                    }, error => {
                        this.ErrorSwal.title = 'Hata';
                        this.ErrorSwal.text = 'Düzenleme yaptığınız otomatın resmi güncellenemedi!';
                        this.ErrorSwal.show();
                        this.spinner.hide();
                    });
                } else {
                    this.SuccessSwal.text = 'Otomat resmi değiştirilmeden başarılı bir şekilde güncellendi!';
                    this.SuccessSwal.show();
                    this.spinner.hide();
                }
            }, error => {
                this.ErrorSwal.title = 'Hata';
                this.ErrorSwal.text = 'Cashless config bilgileri güncellenemedi!';
                this.ErrorSwal.show();
                this.spinner.hide();
            });

        }, error => {
            this.ErrorSwal.title = 'Hata';
            this.ErrorSwal.text = 'Otomatın bilgileri güncellenemedi!';
            this.ErrorSwal.show();
            this.spinner.hide();
        });
    }
    close() {
        this.activeModal.close({success: true, message: 'Kapat', data: null});
    }
    getEditedDatas() {
        const data: any = {};
        if (this.automat.name != this.serviceAutomat.name) {
            data.name = this.automat.name;
        }
        if (this.automat.serial != this.serviceAutomat.serial) {
            data.serial = this.automat.serial;
        }
        if (this.automat.operator != this.serviceAutomat.operator) {
            data.operator = this.automat.operator;
        }
        if (this.automat.group != this.serviceAutomat.group) {
            data.group = this.automat.group;
        }
        if (this.automat.automatModel != this.serviceAutomat.automatModel) {
            data.automatModel = this.automat.automatModel;
        }
        if (this.automat.province != this.serviceAutomat.province) {
            data.province = this.automat.province;
        }
        if (this.automat.district != this.serviceAutomat.district) {
            data.district = this.automat.district;
        }
        if (this.automat.neighborhood != this.serviceAutomat.neighborhood) {
            data.neighborhood = this.automat.neighborhood;
        }
        if (this.automat.isStock != this.serviceAutomat.isStock) {
            data.isStock = this.automat.isStock;
        }
        if (this.automat.isCoin != this.serviceAutomat.isCoin) {
            data.isCoin = this.automat.isCoin;
        }
        if (this.automat.isCard != this.serviceAutomat.isCard) {
            data.isCard = this.automat.isCard;
        }
        if (this.automat.isPreSalesCard != this.serviceAutomat.isPreSalesCard) {
            data.isPreSalesCard = this.automat.isPreSalesCard;
        }
        if (this.automat.isMobil != this.serviceAutomat.isMobil) {
            data.isMobil = this.automat.isMobil;
        }
        if (this.automat.description != this.serviceAutomat.description) {
            data.description = this.automat.description;
        }
        if (this.automat.device != this.serviceAutomat.device) {
            data.device = this.automat.device;
        }
        if (this.automat.vPos != this.serviceAutomat.vPos) {
            data.vPos = this.automat.vPos;
        }
        if (this.automat.beacon != this.serviceAutomat.beacon) {
            data.beacon = this.automat.beacon;
        }
        if (this.automat.sim != this.serviceAutomat.sim) {
            data.sim = this.automat.sim;
        }
        if (this.automat.modem != this.serviceAutomat.modem) {
            data.modem = this.automat.modem;
        }
        if (this.automat.headStart != this.serviceAutomat.headStart) {
            data.headStart = this.automat.headStart;
        }
        if (this.automat.firm != this.serviceAutomat.firm) {
            data.firm = this.automat.firm;
        }
        return data;
    }

    // Image crop functions
    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
    }

    imageCropped(image: string) {
        this.croppedImage = image;
    }

    imageLoaded() {
        this.cropperReady = true;
    }

    imageLoadFailed() {
        this.ErrorSwal.text = 'Seçtiğiniz resim işlenirken sorun oluştu! Lütfen farklı bir resim deneyiniz';
        this.ErrorSwal.show();
    }

    // END : Image crop functions

    navigateTo(path: string) {
        this.router.navigate([path]);
    }

    validatePrice(event: KeyboardEvent, val) {
        if (event.code !== 'Backspace') {
          const check = new RegExp(/^[0-9]*[.,]?([0-9][0-9]?)?$/igm);
          const checkstr = (val || '') + '' + event.key;
          if (!check.test(checkstr)) {
            event.preventDefault();
          }
        }
    }

    selectAddress(){
        this.geocodingHelperService.getLatLngFromAdress(this.automat.province, this.automat.district, this.automat.neighborhood).subscribe(
          latlng => {
            this.mapAutomat.lat = latlng.results[0].geometry.location.lat;
            this.mapAutomat.lng = latlng.results[0].geometry.location.lng;
            this.automat.location.coordinates = [this.mapAutomat.lat, this.mapAutomat.lng];
          });
    }

    onScrollBrand() {
        if (this.page + 1 > this.pages) { return; }
          $('#page-loader').fadeIn();
          this.page += 1;
          this.automatBrandService.getAllBrands(this.page)
              .subscribe(response => {
                  $('#page-loader').fadeOut();
                  for (const item of response.docs) {
                      this.brands.push(item);
                      this.brands = [...this.brands];
                  }
                  this.pages = response.pages;
              }, error => {
                  $('#page-loader').fadeOut();
                  this.ErrorSwal.title = 'Automat devamı yüklenemedi!';
                  this.ErrorSwal.show();      
              });
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/edit-automat/edit-automat.component.ts